import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const Languages = lazy(() => import("../layout/language/Languages"));
const AddLanguage = lazy(() => import("../layout/language/AddLanguage"));

function LanguagePage() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <Languages />
          </Suspense>
        }
      />
      <Route
        path="/add"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <AddLanguage />
          </Suspense>
        }
      />
      <Route
        path="/update/:code"
        element={
          <Suspense fallback={<div>Loading</div>}>
            <AddLanguage />
          </Suspense>
        }
      />
    </Routes>
  );
}

export default LanguagePage;
